"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Main = exports.MainLayout = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../app");
const edit_booking_window_1 = require("../calendar/edit_booking_window");
const auth_1 = require("../utils/auth");
const confirm_1 = require("../utils/confirm");
const helpers_1 = require("../utils/helpers");
const notification_center_1 = require("../widgets/notification_center");
const right_panel_1 = require("../widgets/right_panel");
const time_machine_1 = require("../widgets/time_machine");
const admin_form_1 = require("./components/admin/admin_form");
const announce_form_1 = require("./components/announce/announce_form");
const announce_popup_1 = require("./components/announce/announce_popup");
const booking_cancel_window_1 = require("./components/booking/booking_cancel_window");
const client_booking_cancel_window_1 = require("./components/booking/client_booking_cancel_window");
const client_form_1 = require("./components/client/client_form");
const commercial_offer_form_1 = require("./components/commercial_offer/commercial_offer_form");
const contract_export_window_1 = require("./components/contract/contract_export_window");
const edit_contract_form_1 = require("./components/contract/edit_contract_form");
const new_contract_form_1 = require("./components/contract/new_contract_form");
const payment_export_window_1 = require("./components/payment/payment_export_window");
const payment_form_1 = require("./components/payment/payment_form");
const payment_scheme_form_1 = require("./components/payment/payment_scheme_form");
const room_form_1 = require("./components/room/room_form");
const venue_form_1 = require("./components/venue/venue_form");
const nav_1 = __importDefault(require("./nav"));
const FORMS = [client_form_1.ClientForm, commercial_offer_form_1.CommercialOfferForm,
    new_contract_form_1.NewContractForm, edit_contract_form_1.EditContractForm,
    booking_cancel_window_1.BookingCancelWindow, venue_form_1.VenueForm,
    room_form_1.RoomForm, announce_form_1.AnnounceForm, admin_form_1.AdminForm, edit_booking_window_1.EditBookingWindow,
    client_booking_cancel_window_1.ClientBookingCancelWindow, payment_export_window_1.PaymentExportWindow,
    announce_popup_1.AnnouncePopup, payment_form_1.PaymentForm, payment_scheme_form_1.PaymentSchemeForm,
    contract_export_window_1.ContractExportWindow
];
function renderTopBar() {
    let rightElements = [];
    let leftElements = [];
    leftElements.push((0, mithril_1.default)(".is-block-touch.is-hidden-desktop", (0, mithril_1.default)("a.is-size-4", {
        href: "#",
        onclick: (evt) => {
            evt.preventDefault();
            exports.Main.navIsOpen = true;
        },
        style: "padding-right: 0.5em;"
    }, (0, helpers_1.iconSpan)("fa-bars"))));
    rightElements.push((0, mithril_1.default)("div", app_1.App.ENV != "production" && auth_1.Auth.isAdmin() && !(0, helpers_1.isMobile)() ? (0, mithril_1.default)(time_machine_1.TimeMachine) : undefined));
    if (auth_1.Auth.isImpersonated()) {
        rightElements.push((0, mithril_1.default)("div", (0, mithril_1.default)("a", { onclick: auth_1.Auth.stopImpersonate }, (0, helpers_1.iconSpan)("fa-sign-out-alt"), (0, mithril_1.default)("span", "Retour admin"))));
    }
    else {
        rightElements.push((0, mithril_1.default)("div", (0, mithril_1.default)("a", { onclick: auth_1.Auth.logout }, (0, helpers_1.iconSpan)("fa-user"), (0, mithril_1.default)("span", "Déconnexion"))));
    }
    return (0, helpers_1.level)({
        left: leftElements,
        right: rightElements,
        opts: {
            style: "padding: 0.25em 1em;",
            class: "level is-mobile"
        }
    });
}
function MainLayout(component) {
    return {
        view() {
            return (0, mithril_1.default)(exports.Main, (0, mithril_1.default)(component));
        }
    };
}
exports.MainLayout = MainLayout;
exports.Main = {
    navIsOpen: false,
    view: (vnode) => {
        return (0, mithril_1.default)("div", { class: "app", key: "app", id: "app" }, [
            (0, mithril_1.default)(".app-left.is-hidden-touch", [
                (0, mithril_1.default)(".app-top-left.logo", (0, mithril_1.default)("img", { src: "/logo_sesame_bw.svg" })),
                (0, mithril_1.default)(".app-bottom", (0, mithril_1.default)(".nav-container", (0, mithril_1.default)(nav_1.default)))
            ]),
            (0, helpers_1.ifTrue)(exports.Main.navIsOpen, (0, mithril_1.default)(".nav-floating.is-block-touch", [
                (0, mithril_1.default)(".app-top-left.logo", (0, mithril_1.default)("img", { src: "/logo_sesame_bw.svg" })),
                (0, mithril_1.default)("a.return", {
                    href: "#",
                    onclick: (e) => { e.preventDefault(); exports.Main.navIsOpen = false; }
                }, (0, helpers_1.iconSpan)("fa-times")),
                (0, mithril_1.default)(".app-bottom", (0, mithril_1.default)(nav_1.default))
            ])),
            (0, mithril_1.default)(".app-right", { class: "" }, [
                (0, mithril_1.default)(".app-top-right.top-bar", renderTopBar()),
                (0, mithril_1.default)(".app-bottom", (0, mithril_1.default)(notification_center_1.Notification), vnode.children, right_panel_1.RightPanel.render())
            ]),
            FORMS.map((f) => (0, mithril_1.default)(f)),
            (0, mithril_1.default)(confirm_1.Confirm)
        ]);
    }
};
